// Generated by scripts/update-worldcup-data.mjs
// Last update: 2026-08-01T07:31:36.464Z

export type WorldCupTeam = { id: number; name: string; fifaCode: string; iso2: string; group: string; flag: string };
export type WorldCupStadium = { id: number; name: string; city: string; country: string; capacity: number };
export type WorldCupMatch = { id: number; type: string; group: string; matchday: number; localDate: string; date: string; home: string; away: string; homeName: string; awayName: string; stadium: string; city: string; country: string; source: string; finished?: boolean; homeScore?: number; awayScore?: number; elapsed?: string };
export type WorldCupGroup = { group: string; teams: string[] };

export const worldCupSource = {
  "liveApi": "https://worldcup26.ir/get/*",
  "updateMode": "live-api",
  "liveError": "",
  "teams": "https://worldcup26.ir/get/teams",
  "groupMatches": "https://worldcup26.ir/get/games",
  "stadiums": "https://worldcup26.ir/get/stadiums",
  "knockout": "openfootball/worldcup/2026--usa/cup_finals.txt fallback remains in repository snapshot",
  "context": "openfootball/worldcup/2026--usa/cup.txt"
} as const;

export const worldCupTeams: WorldCupTeam[] = [
  {
    "id": 2,
    "name": "South Africa",
    "fifaCode": "RSA",
    "iso2": "ZA",
    "group": "A",
    "flag": "https://flagcdn.com/w80/za.png"
  },
  {
    "id": 9,
    "name": "Brazil",
    "fifaCode": "BRA",
    "iso2": "BR",
    "group": "C",
    "flag": "https://flagcdn.com/w80/br.png"
  },
  {
    "id": 12,
    "name": "Scotland",
    "fifaCode": "SCO",
    "iso2": "SCO",
    "group": "C",
    "flag": "https://flagcdn.com/w80/gb-sct.png"
  },
  {
    "id": 16,
    "name": "Turkey",
    "fifaCode": "TUR",
    "iso2": "TR",
    "group": "D",
    "flag": "https://flagcdn.com/w80/tr.png"
  },
  {
    "id": 19,
    "name": "Ivory Coast",
    "fifaCode": "CIV",
    "iso2": "CI",
    "group": "E",
    "flag": "https://flagcdn.com/w80/ci.png"
  },
  {
    "id": 21,
    "name": "Netherlands",
    "fifaCode": "NED",
    "iso2": "NL",
    "group": "F",
    "flag": "https://flagcdn.com/w80/nl.png"
  },
  {
    "id": 30,
    "name": "Cape Verde",
    "fifaCode": "CPV",
    "iso2": "CV",
    "group": "H",
    "flag": "https://flagcdn.com/w80/cv.png"
  },
  {
    "id": 33,
    "name": "France",
    "fifaCode": "FRA",
    "iso2": "FR",
    "group": "I",
    "flag": "https://flagcdn.com/w80/fr.png"
  },
  {
    "id": 24,
    "name": "Tunisia",
    "fifaCode": "TUN",
    "iso2": "TN",
    "group": "F",
    "flag": "https://flagcdn.com/w80/tn.png"
  },
  {
    "id": 26,
    "name": "Egypt",
    "fifaCode": "EGY",
    "iso2": "EG",
    "group": "G",
    "flag": "https://flagcdn.com/w80/eg.png"
  },
  {
    "id": 35,
    "name": "Iraq",
    "fifaCode": "IRQ",
    "iso2": "IQ",
    "group": "I",
    "flag": "https://flagcdn.com/w80/iq.png"
  },
  {
    "id": 41,
    "name": "Portugal",
    "fifaCode": "POR",
    "iso2": "PT",
    "group": "K",
    "flag": "https://flagcdn.com/w80/pt.png"
  },
  {
    "id": 43,
    "name": "Uzbekistan",
    "fifaCode": "UZB",
    "iso2": "UZ",
    "group": "K",
    "flag": "https://flagcdn.com/w80/uz.png"
  },
  {
    "id": 44,
    "name": "Colombia",
    "fifaCode": "COL",
    "iso2": "CO",
    "group": "K",
    "flag": "https://flagcdn.com/w80/co.png"
  },
  {
    "id": 20,
    "name": "Ecuador",
    "fifaCode": "ECU",
    "iso2": "EC",
    "group": "E",
    "flag": "https://flagcdn.com/w80/ec.png"
  },
  {
    "id": 22,
    "name": "Japan",
    "fifaCode": "JPN",
    "iso2": "JP",
    "group": "F",
    "flag": "https://flagcdn.com/w80/jp.png"
  },
  {
    "id": 28,
    "name": "New Zealand",
    "fifaCode": "NZL",
    "iso2": "NZ",
    "group": "G",
    "flag": "https://flagcdn.com/w80/nz.png"
  },
  {
    "id": 31,
    "name": "Saudi Arabia",
    "fifaCode": "KSA",
    "iso2": "SA",
    "group": "H",
    "flag": "https://flagcdn.com/w80/sa.png"
  },
  {
    "id": 39,
    "name": "Austria",
    "fifaCode": "AUT",
    "iso2": "AT",
    "group": "J",
    "flag": "https://flagcdn.com/w80/at.png"
  },
  {
    "id": 47,
    "name": "Ghana",
    "fifaCode": "GHA",
    "iso2": "GH",
    "group": "L",
    "flag": "https://flagcdn.com/w80/gh.png"
  },
  {
    "id": 3,
    "name": "South Korea",
    "fifaCode": "KOR",
    "iso2": "KR",
    "group": "A",
    "flag": "https://flagcdn.com/w80/kr.png"
  },
  {
    "id": 29,
    "name": "Spain",
    "fifaCode": "ESP",
    "iso2": "ES",
    "group": "H",
    "flag": "https://flagcdn.com/w80/es.png"
  },
  {
    "id": 36,
    "name": "Norway",
    "fifaCode": "NOR",
    "iso2": "NO",
    "group": "I",
    "flag": "https://flagcdn.com/w80/no.png"
  },
  {
    "id": 37,
    "name": "Argentina",
    "fifaCode": "ARG",
    "iso2": "AR",
    "group": "J",
    "flag": "https://flagcdn.com/w80/ar.png"
  },
  {
    "id": 42,
    "name": "Democratic Republic of the Congo",
    "fifaCode": "COD",
    "iso2": "CD",
    "group": "K",
    "flag": "https://flagcdn.com/w80/cd.png"
  },
  {
    "id": 45,
    "name": "England",
    "fifaCode": "ENG",
    "iso2": "ENG",
    "group": "L",
    "flag": "https://flagcdn.com/w80/gb-eng.png"
  },
  {
    "id": 4,
    "name": "Czech Republic",
    "fifaCode": "CZE",
    "iso2": "CZ",
    "group": "A",
    "flag": "https://flagcdn.com/w80/cz.png"
  },
  {
    "id": 5,
    "name": "Canada",
    "fifaCode": "CAN",
    "iso2": "CA",
    "group": "B",
    "flag": "https://flagcdn.com/w80/ca.png"
  },
  {
    "id": 7,
    "name": "Qatar",
    "fifaCode": "QAT",
    "iso2": "QA",
    "group": "B",
    "flag": "https://flagcdn.com/w80/qa.png"
  },
  {
    "id": 8,
    "name": "Switzerland",
    "fifaCode": "SUI",
    "iso2": "CH",
    "group": "B",
    "flag": "https://flagcdn.com/w80/ch.png"
  },
  {
    "id": 10,
    "name": "Morocco",
    "fifaCode": "MAR",
    "iso2": "MA",
    "group": "C",
    "flag": "https://flagcdn.com/w80/ma.png"
  },
  {
    "id": 14,
    "name": "Paraguay",
    "fifaCode": "PAR",
    "iso2": "PY",
    "group": "D",
    "flag": "https://flagcdn.com/w80/py.png"
  },
  {
    "id": 18,
    "name": "Curaçao",
    "fifaCode": "CUW",
    "iso2": "CW",
    "group": "E",
    "flag": "https://flagcdn.com/w80/cw.png"
  },
  {
    "id": 23,
    "name": "Sweden",
    "fifaCode": "SWE",
    "iso2": "SE",
    "group": "F",
    "flag": "https://flagcdn.com/w80/se.png"
  },
  {
    "id": 38,
    "name": "Algeria",
    "fifaCode": "ALG",
    "iso2": "DZ",
    "group": "J",
    "flag": "https://flagcdn.com/w80/dz.png"
  },
  {
    "id": 40,
    "name": "Jordan",
    "fifaCode": "JOR",
    "iso2": "JO",
    "group": "J",
    "flag": "https://flagcdn.com/w80/jo.png"
  },
  {
    "id": 11,
    "name": "Haiti",
    "fifaCode": "HAI",
    "iso2": "HT",
    "group": "C",
    "flag": "https://flagcdn.com/w80/ht.png"
  },
  {
    "id": 17,
    "name": "Germany",
    "fifaCode": "GER",
    "iso2": "DE",
    "group": "E",
    "flag": "https://flagcdn.com/w80/de.png"
  },
  {
    "id": 32,
    "name": "Uruguay",
    "fifaCode": "URU",
    "iso2": "UY",
    "group": "H",
    "flag": "https://flagcdn.com/w80/uy.png"
  },
  {
    "id": 34,
    "name": "Senegal",
    "fifaCode": "SEN",
    "iso2": "SN",
    "group": "I",
    "flag": "https://flagcdn.com/w80/sn.png"
  },
  {
    "id": 48,
    "name": "Panama",
    "fifaCode": "PAN",
    "iso2": "PA",
    "group": "L",
    "flag": "https://flagcdn.com/w80/pa.png"
  },
  {
    "id": 1,
    "name": "Mexico",
    "fifaCode": "MEX",
    "iso2": "MX",
    "group": "A",
    "flag": "https://flagcdn.com/w80/mx.png"
  },
  {
    "id": 6,
    "name": "Bosnia and Herzegovina",
    "fifaCode": "BIH",
    "iso2": "BA",
    "group": "B",
    "flag": "https://flagcdn.com/w80/ba.png"
  },
  {
    "id": 13,
    "name": "United States",
    "fifaCode": "USA",
    "iso2": "US",
    "group": "D",
    "flag": "https://flagcdn.com/w80/us.png"
  },
  {
    "id": 15,
    "name": "Australia",
    "fifaCode": "AUS",
    "iso2": "AU",
    "group": "D",
    "flag": "https://flagcdn.com/w80/au.png"
  },
  {
    "id": 25,
    "name": "Belgium",
    "fifaCode": "BEL",
    "iso2": "BE",
    "group": "G",
    "flag": "https://flagcdn.com/w80/be.png"
  },
  {
    "id": 27,
    "name": "Iran",
    "fifaCode": "IRN",
    "iso2": "IR",
    "group": "G",
    "flag": "https://flagcdn.com/w80/ir.png"
  },
  {
    "id": 46,
    "name": "Croatia",
    "fifaCode": "CRO",
    "iso2": "HR",
    "group": "L",
    "flag": "https://flagcdn.com/w80/hr.png"
  }
];

export const worldCupStadiums: WorldCupStadium[] = [
  {
    "id": 14,
    "name": "Lumen Field",
    "city": "Seattle",
    "country": "United States",
    "capacity": 69000
  },
  {
    "id": 8,
    "name": "Hard Rock Stadium",
    "city": "Miami (Miami Gardens)",
    "country": "United States",
    "capacity": 65000
  },
  {
    "id": 13,
    "name": "BC Place",
    "city": "Vancouver",
    "country": "Canada",
    "capacity": 54000
  },
  {
    "id": 15,
    "name": "Levi's Stadium",
    "city": "San Francisco Bay Area (Santa Clara)",
    "country": "United States",
    "capacity": 71000
  },
  {
    "id": 3,
    "name": "Estadio BBVA",
    "city": "Monterrey (Guadalupe)",
    "country": "Mexico",
    "capacity": 53500
  },
  {
    "id": 1,
    "name": "Estadio Azteca",
    "city": "Mexico City",
    "country": "Mexico",
    "capacity": 83000
  },
  {
    "id": 2,
    "name": "Estadio Akron",
    "city": "Guadalajara (Zapopan)",
    "country": "Mexico",
    "capacity": 48000
  },
  {
    "id": 5,
    "name": "NRG Stadium",
    "city": "Houston",
    "country": "United States",
    "capacity": 72000
  },
  {
    "id": 16,
    "name": "SoFi Stadium",
    "city": "Los Angeles (Inglewood)",
    "country": "United States",
    "capacity": 70000
  },
  {
    "id": 7,
    "name": "Mercedes-Benz Stadium",
    "city": "Atlanta",
    "country": "United States",
    "capacity": 75000
  },
  {
    "id": 9,
    "name": "Gillette Stadium",
    "city": "Boston (Foxborough)",
    "country": "United States",
    "capacity": 65000
  },
  {
    "id": 6,
    "name": "GEHA Field at Arrowhead Stadium",
    "city": "Kansas City",
    "country": "United States",
    "capacity": 73000
  },
  {
    "id": 10,
    "name": "Lincoln Financial Field",
    "city": "Philadelphia",
    "country": "United States",
    "capacity": 69000
  },
  {
    "id": 4,
    "name": "AT&T Stadium",
    "city": "Dallas (Arlington, Texas)",
    "country": "United States",
    "capacity": 94000
  },
  {
    "id": 11,
    "name": "MetLife Stadium",
    "city": "New York/New Jersey (East Rutherford)",
    "country": "United States",
    "capacity": 82500
  },
  {
    "id": 12,
    "name": "BMO Field",
    "city": "Toronto",
    "country": "Canada",
    "capacity": 45000
  }
];

export const worldCupGroups: WorldCupGroup[] = [
  {
    "group": "A",
    "teams": [
      "RSA",
      "KOR",
      "CZE",
      "MEX"
    ]
  },
  {
    "group": "B",
    "teams": [
      "CAN",
      "QAT",
      "SUI",
      "BIH"
    ]
  },
  {
    "group": "C",
    "teams": [
      "BRA",
      "SCO",
      "MAR",
      "HAI"
    ]
  },
  {
    "group": "D",
    "teams": [
      "TUR",
      "PAR",
      "USA",
      "AUS"
    ]
  },
  {
    "group": "E",
    "teams": [
      "CIV",
      "ECU",
      "CUW",
      "GER"
    ]
  },
  {
    "group": "F",
    "teams": [
      "NED",
      "TUN",
      "JPN",
      "SWE"
    ]
  },
  {
    "group": "G",
    "teams": [
      "EGY",
      "NZL",
      "BEL",
      "IRN"
    ]
  },
  {
    "group": "H",
    "teams": [
      "CPV",
      "KSA",
      "ESP",
      "URU"
    ]
  },
  {
    "group": "I",
    "teams": [
      "FRA",
      "IRQ",
      "NOR",
      "SEN"
    ]
  },
  {
    "group": "J",
    "teams": [
      "AUT",
      "ARG",
      "ALG",
      "JOR"
    ]
  },
  {
    "group": "K",
    "teams": [
      "POR",
      "UZB",
      "COL",
      "COD"
    ]
  },
  {
    "group": "L",
    "teams": [
      "GHA",
      "ENG",
      "PAN",
      "CRO"
    ]
  }
];

export const worldCupMatches: WorldCupMatch[] = [
  {
    "id": 1,
    "type": "group",
    "group": "A",
    "matchday": 1,
    "localDate": "06/11/2026 13:00",
    "date": "",
    "home": "MEX",
    "away": "RSA",
    "homeName": "Mexico",
    "awayName": "South Africa",
    "stadium": "Estadio Azteca",
    "city": "Mexico City",
    "country": "Mexico",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 2,
    "awayScore": 0,
    "elapsed": "finished"
  },
  {
    "id": 2,
    "type": "group",
    "group": "A",
    "matchday": 1,
    "localDate": "06/11/2026 20:00",
    "date": "",
    "home": "KOR",
    "away": "CZE",
    "homeName": "South Korea",
    "awayName": "Czech Republic",
    "stadium": "Estadio Akron",
    "city": "Guadalajara (Zapopan)",
    "country": "Mexico",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 2,
    "awayScore": 1,
    "elapsed": "finished"
  },
  {
    "id": 3,
    "type": "group",
    "group": "B",
    "matchday": 1,
    "localDate": "06/12/2026 15:00",
    "date": "",
    "home": "CAN",
    "away": "BIH",
    "homeName": "Canada",
    "awayName": "Bosnia and Herzegovina",
    "stadium": "BMO Field",
    "city": "Toronto",
    "country": "Canada",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 1,
    "awayScore": 1,
    "elapsed": "finished"
  },
  {
    "id": 4,
    "type": "group",
    "group": "D",
    "matchday": 1,
    "localDate": "06/12/2026 18:00",
    "date": "",
    "home": "USA",
    "away": "PAR",
    "homeName": "United States",
    "awayName": "Paraguay",
    "stadium": "SoFi Stadium",
    "city": "Los Angeles (Inglewood)",
    "country": "United States",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 4,
    "awayScore": 1,
    "elapsed": "finished"
  },
  {
    "id": 5,
    "type": "group",
    "group": "C",
    "matchday": 1,
    "localDate": "06/13/2026 21:00",
    "date": "",
    "home": "HAI",
    "away": "SCO",
    "homeName": "Haiti",
    "awayName": "Scotland",
    "stadium": "Gillette Stadium",
    "city": "Boston (Foxborough)",
    "country": "United States",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 0,
    "awayScore": 1,
    "elapsed": "finished"
  },
  {
    "id": 6,
    "type": "group",
    "group": "D",
    "matchday": 1,
    "localDate": "06/13/2026 21:00",
    "date": "",
    "home": "AUS",
    "away": "TUR",
    "homeName": "Australia",
    "awayName": "Turkey",
    "stadium": "BC Place",
    "city": "Vancouver",
    "country": "Canada",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 2,
    "awayScore": 0,
    "elapsed": "finished"
  },
  {
    "id": 7,
    "type": "group",
    "group": "C",
    "matchday": 1,
    "localDate": "06/13/2026 18:00",
    "date": "",
    "home": "BRA",
    "away": "MAR",
    "homeName": "Brazil",
    "awayName": "Morocco",
    "stadium": "MetLife Stadium",
    "city": "New York/New Jersey (East Rutherford)",
    "country": "United States",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 1,
    "awayScore": 1,
    "elapsed": "finished"
  },
  {
    "id": 8,
    "type": "group",
    "group": "B",
    "matchday": 1,
    "localDate": "06/13/2026 12:00",
    "date": "",
    "home": "QAT",
    "away": "SUI",
    "homeName": "Qatar",
    "awayName": "Switzerland",
    "stadium": "Levi's Stadium",
    "city": "San Francisco Bay Area (Santa Clara)",
    "country": "United States",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 1,
    "awayScore": 1,
    "elapsed": "finished"
  },
  {
    "id": 9,
    "type": "group",
    "group": "E",
    "matchday": 1,
    "localDate": "06/14/2026 19:00",
    "date": "",
    "home": "CIV",
    "away": "ECU",
    "homeName": "Ivory Coast",
    "awayName": "Ecuador",
    "stadium": "Lincoln Financial Field",
    "city": "Philadelphia",
    "country": "United States",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 1,
    "awayScore": 0,
    "elapsed": "finished"
  },
  {
    "id": 10,
    "type": "group",
    "group": "E",
    "matchday": 1,
    "localDate": "06/14/2026 12:00",
    "date": "",
    "home": "GER",
    "away": "CUW",
    "homeName": "Germany",
    "awayName": "Curaçao",
    "stadium": "NRG Stadium",
    "city": "Houston",
    "country": "United States",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 7,
    "awayScore": 1,
    "elapsed": "finished"
  },
  {
    "id": 11,
    "type": "group",
    "group": "F",
    "matchday": 1,
    "localDate": "06/14/2026 15:00",
    "date": "",
    "home": "NED",
    "away": "JPN",
    "homeName": "Netherlands",
    "awayName": "Japan",
    "stadium": "AT&T Stadium",
    "city": "Dallas (Arlington, Texas)",
    "country": "United States",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 2,
    "awayScore": 2,
    "elapsed": "finished"
  },
  {
    "id": 12,
    "type": "group",
    "group": "F",
    "matchday": 1,
    "localDate": "06/14/2026 20:00",
    "date": "",
    "home": "SWE",
    "away": "TUN",
    "homeName": "Sweden",
    "awayName": "Tunisia",
    "stadium": "Estadio BBVA",
    "city": "Monterrey (Guadalupe)",
    "country": "Mexico",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 5,
    "awayScore": 1,
    "elapsed": "finished"
  },
  {
    "id": 13,
    "type": "group",
    "group": "G",
    "matchday": 1,
    "localDate": "06/15/2026 18:00",
    "date": "",
    "home": "IRN",
    "away": "NZL",
    "homeName": "Iran",
    "awayName": "New Zealand",
    "stadium": "SoFi Stadium",
    "city": "Los Angeles (Inglewood)",
    "country": "United States",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 2,
    "awayScore": 2,
    "elapsed": "finished"
  },
  {
    "id": 14,
    "type": "group",
    "group": "H",
    "matchday": 1,
    "localDate": "06/15/2026 12:00",
    "date": "",
    "home": "ESP",
    "away": "CPV",
    "homeName": "Spain",
    "awayName": "Cape Verde",
    "stadium": "Mercedes-Benz Stadium",
    "city": "Atlanta",
    "country": "United States",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 0,
    "awayScore": 0,
    "elapsed": "finished"
  },
  {
    "id": 15,
    "type": "group",
    "group": "G",
    "matchday": 1,
    "localDate": "06/15/2026 12:00",
    "date": "",
    "home": "BEL",
    "away": "EGY",
    "homeName": "Belgium",
    "awayName": "Egypt",
    "stadium": "Lumen Field",
    "city": "Seattle",
    "country": "United States",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 1,
    "awayScore": 1,
    "elapsed": "finished"
  },
  {
    "id": 16,
    "type": "group",
    "group": "H",
    "matchday": 1,
    "localDate": "06/15/2026 18:00",
    "date": "",
    "home": "KSA",
    "away": "URU",
    "homeName": "Saudi Arabia",
    "awayName": "Uruguay",
    "stadium": "Hard Rock Stadium",
    "city": "Miami (Miami Gardens)",
    "country": "United States",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 1,
    "awayScore": 1,
    "elapsed": "finished"
  },
  {
    "id": 17,
    "type": "group",
    "group": "I",
    "matchday": 1,
    "localDate": "06/16/2026 15:00",
    "date": "",
    "home": "FRA",
    "away": "SEN",
    "homeName": "France",
    "awayName": "Senegal",
    "stadium": "MetLife Stadium",
    "city": "New York/New Jersey (East Rutherford)",
    "country": "United States",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 3,
    "awayScore": 1,
    "elapsed": "finished"
  },
  {
    "id": 18,
    "type": "group",
    "group": "I",
    "matchday": 1,
    "localDate": "06/16/2026 18:00",
    "date": "",
    "home": "IRQ",
    "away": "NOR",
    "homeName": "Iraq",
    "awayName": "Norway",
    "stadium": "Gillette Stadium",
    "city": "Boston (Foxborough)",
    "country": "United States",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 1,
    "awayScore": 4,
    "elapsed": "finished"
  },
  {
    "id": 19,
    "type": "group",
    "group": "J",
    "matchday": 1,
    "localDate": "06/16/2026 20:00",
    "date": "",
    "home": "ARG",
    "away": "ALG",
    "homeName": "Argentina",
    "awayName": "Algeria",
    "stadium": "GEHA Field at Arrowhead Stadium",
    "city": "Kansas City",
    "country": "United States",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 3,
    "awayScore": 0,
    "elapsed": "finished"
  },
  {
    "id": 20,
    "type": "group",
    "group": "J",
    "matchday": 1,
    "localDate": "06/16/2026 21:00",
    "date": "",
    "home": "AUT",
    "away": "JOR",
    "homeName": "Austria",
    "awayName": "Jordan",
    "stadium": "Levi's Stadium",
    "city": "San Francisco Bay Area (Santa Clara)",
    "country": "United States",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 3,
    "awayScore": 1,
    "elapsed": "finished"
  },
  {
    "id": 21,
    "type": "group",
    "group": "K",
    "matchday": 1,
    "localDate": "06/17/2026 12:00",
    "date": "",
    "home": "POR",
    "away": "COD",
    "homeName": "Portugal",
    "awayName": "Democratic Republic of the Congo",
    "stadium": "NRG Stadium",
    "city": "Houston",
    "country": "United States",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 1,
    "awayScore": 1,
    "elapsed": "Finished"
  },
  {
    "id": 22,
    "type": "group",
    "group": "L",
    "matchday": 1,
    "localDate": "06/17/2026 15:00",
    "date": "",
    "home": "ENG",
    "away": "CRO",
    "homeName": "England",
    "awayName": "Croatia",
    "stadium": "AT&T Stadium",
    "city": "Dallas (Arlington, Texas)",
    "country": "United States",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 4,
    "awayScore": 2,
    "elapsed": "finished"
  },
  {
    "id": 23,
    "type": "group",
    "group": "K",
    "matchday": 1,
    "localDate": "06/17/2026 20:00",
    "date": "",
    "home": "UZB",
    "away": "COL",
    "homeName": "Uzbekistan",
    "awayName": "Colombia",
    "stadium": "Estadio Azteca",
    "city": "Mexico City",
    "country": "Mexico",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 1,
    "awayScore": 3,
    "elapsed": "finished"
  },
  {
    "id": 24,
    "type": "group",
    "group": "L",
    "matchday": 1,
    "localDate": "06/17/2026 19:00",
    "date": "",
    "home": "GHA",
    "away": "PAN",
    "homeName": "Ghana",
    "awayName": "Panama",
    "stadium": "BMO Field",
    "city": "Toronto",
    "country": "Canada",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 1,
    "awayScore": 0,
    "elapsed": "finished"
  },
  {
    "id": 25,
    "type": "group",
    "group": "A",
    "matchday": 2,
    "localDate": "06/18/2026 19:00",
    "date": "",
    "home": "MEX",
    "away": "KOR",
    "homeName": "Mexico",
    "awayName": "South Korea",
    "stadium": "Estadio Akron",
    "city": "Guadalajara (Zapopan)",
    "country": "Mexico",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 1,
    "awayScore": 0,
    "elapsed": "finished"
  },
  {
    "id": 26,
    "type": "group",
    "group": "B",
    "matchday": 2,
    "localDate": "06/18/2026 12:00",
    "date": "",
    "home": "SUI",
    "away": "BIH",
    "homeName": "Switzerland",
    "awayName": "Bosnia and Herzegovina",
    "stadium": "SoFi Stadium",
    "city": "Los Angeles (Inglewood)",
    "country": "United States",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 4,
    "awayScore": 1,
    "elapsed": "finished"
  },
  {
    "id": 27,
    "type": "group",
    "group": "B",
    "matchday": 2,
    "localDate": "06/18/2026 15:00",
    "date": "",
    "home": "CAN",
    "away": "QAT",
    "homeName": "Canada",
    "awayName": "Qatar",
    "stadium": "BC Place",
    "city": "Vancouver",
    "country": "Canada",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 6,
    "awayScore": 0,
    "elapsed": "finished"
  },
  {
    "id": 28,
    "type": "group",
    "group": "A",
    "matchday": 2,
    "localDate": "06/18/2026 12:00",
    "date": "",
    "home": "CZE",
    "away": "RSA",
    "homeName": "Czech Republic",
    "awayName": "South Africa",
    "stadium": "Mercedes-Benz Stadium",
    "city": "Atlanta",
    "country": "United States",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 1,
    "awayScore": 1,
    "elapsed": "finished"
  },
  {
    "id": 29,
    "type": "group",
    "group": "C",
    "matchday": 2,
    "localDate": "06/19/2026 21:00",
    "date": "",
    "home": "BRA",
    "away": "HAI",
    "homeName": "Brazil",
    "awayName": "Haiti",
    "stadium": "Lincoln Financial Field",
    "city": "Philadelphia",
    "country": "United States",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 3,
    "awayScore": 0,
    "elapsed": "finished"
  },
  {
    "id": 30,
    "type": "group",
    "group": "C",
    "matchday": 2,
    "localDate": "06/19/2026 18:00",
    "date": "",
    "home": "SCO",
    "away": "MAR",
    "homeName": "Scotland",
    "awayName": "Morocco",
    "stadium": "Gillette Stadium",
    "city": "Boston (Foxborough)",
    "country": "United States",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 0,
    "awayScore": 1,
    "elapsed": "finished"
  },
  {
    "id": 31,
    "type": "group",
    "group": "D",
    "matchday": 2,
    "localDate": "06/19/2026 12:00",
    "date": "",
    "home": "USA",
    "away": "AUS",
    "homeName": "United States",
    "awayName": "Australia",
    "stadium": "Lumen Field",
    "city": "Seattle",
    "country": "United States",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 2,
    "awayScore": 0,
    "elapsed": "finished"
  },
  {
    "id": 32,
    "type": "group",
    "group": "D",
    "matchday": 2,
    "localDate": "06/19/2026 20:00",
    "date": "",
    "home": "TUR",
    "away": "PAR",
    "homeName": "Turkey",
    "awayName": "Paraguay",
    "stadium": "Levi's Stadium",
    "city": "San Francisco Bay Area (Santa Clara)",
    "country": "United States",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 0,
    "awayScore": 1,
    "elapsed": "finished"
  },
  {
    "id": 33,
    "type": "group",
    "group": "E",
    "matchday": 2,
    "localDate": "06/20/2026 16:00",
    "date": "",
    "home": "GER",
    "away": "CIV",
    "homeName": "Germany",
    "awayName": "Ivory Coast",
    "stadium": "BMO Field",
    "city": "Toronto",
    "country": "Canada",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 2,
    "awayScore": 1,
    "elapsed": "finished"
  },
  {
    "id": 34,
    "type": "group",
    "group": "E",
    "matchday": 2,
    "localDate": "06/20/2026 19:00",
    "date": "",
    "home": "ECU",
    "away": "CUW",
    "homeName": "Ecuador",
    "awayName": "Curaçao",
    "stadium": "GEHA Field at Arrowhead Stadium",
    "city": "Kansas City",
    "country": "United States",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 0,
    "awayScore": 0,
    "elapsed": "finished"
  },
  {
    "id": 35,
    "type": "group",
    "group": "F",
    "matchday": 2,
    "localDate": "06/20/2026 12:00",
    "date": "",
    "home": "NED",
    "away": "SWE",
    "homeName": "Netherlands",
    "awayName": "Sweden",
    "stadium": "NRG Stadium",
    "city": "Houston",
    "country": "United States",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 5,
    "awayScore": 1,
    "elapsed": "finished"
  },
  {
    "id": 36,
    "type": "group",
    "group": "F",
    "matchday": 2,
    "localDate": "06/20/2026 22:00",
    "date": "",
    "home": "TUN",
    "away": "JPN",
    "homeName": "Tunisia",
    "awayName": "Japan",
    "stadium": "Estadio BBVA",
    "city": "Monterrey (Guadalupe)",
    "country": "Mexico",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 0,
    "awayScore": 4,
    "elapsed": "finished"
  },
  {
    "id": 37,
    "type": "group",
    "group": "G",
    "matchday": 2,
    "localDate": "06/21/2026 12:00",
    "date": "",
    "home": "BEL",
    "away": "IRN",
    "homeName": "Belgium",
    "awayName": "Iran",
    "stadium": "SoFi Stadium",
    "city": "Los Angeles (Inglewood)",
    "country": "United States",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 0,
    "awayScore": 0,
    "elapsed": "finished"
  },
  {
    "id": 38,
    "type": "group",
    "group": "G",
    "matchday": 2,
    "localDate": "06/21/2026 18:00",
    "date": "",
    "home": "NZL",
    "away": "EGY",
    "homeName": "New Zealand",
    "awayName": "Egypt",
    "stadium": "BC Place",
    "city": "Vancouver",
    "country": "Canada",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 1,
    "awayScore": 3,
    "elapsed": "finished"
  },
  {
    "id": 39,
    "type": "group",
    "group": "H",
    "matchday": 2,
    "localDate": "06/21/2026 12:00",
    "date": "",
    "home": "ESP",
    "away": "KSA",
    "homeName": "Spain",
    "awayName": "Saudi Arabia",
    "stadium": "Mercedes-Benz Stadium",
    "city": "Atlanta",
    "country": "United States",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 4,
    "awayScore": 0,
    "elapsed": "finished"
  },
  {
    "id": 40,
    "type": "group",
    "group": "H",
    "matchday": 2,
    "localDate": "06/21/2026 18:00",
    "date": "",
    "home": "URU",
    "away": "CPV",
    "homeName": "Uruguay",
    "awayName": "Cape Verde",
    "stadium": "Hard Rock Stadium",
    "city": "Miami (Miami Gardens)",
    "country": "United States",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 2,
    "awayScore": 2,
    "elapsed": "finished"
  },
  {
    "id": 41,
    "type": "group",
    "group": "I",
    "matchday": 2,
    "localDate": "06/22/2026 17:00",
    "date": "",
    "home": "FRA",
    "away": "IRQ",
    "homeName": "France",
    "awayName": "Iraq",
    "stadium": "Lincoln Financial Field",
    "city": "Philadelphia",
    "country": "United States",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 3,
    "awayScore": 0,
    "elapsed": "finished"
  },
  {
    "id": 42,
    "type": "group",
    "group": "I",
    "matchday": 2,
    "localDate": "06/22/2026 20:00",
    "date": "",
    "home": "NOR",
    "away": "SEN",
    "homeName": "Norway",
    "awayName": "Senegal",
    "stadium": "MetLife Stadium",
    "city": "New York/New Jersey (East Rutherford)",
    "country": "United States",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 3,
    "awayScore": 2,
    "elapsed": "finished"
  },
  {
    "id": 43,
    "type": "group",
    "group": "J",
    "matchday": 2,
    "localDate": "06/22/2026 12:00",
    "date": "",
    "home": "ARG",
    "away": "AUT",
    "homeName": "Argentina",
    "awayName": "Austria",
    "stadium": "AT&T Stadium",
    "city": "Dallas (Arlington, Texas)",
    "country": "United States",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 2,
    "awayScore": 0,
    "elapsed": "finished"
  },
  {
    "id": 44,
    "type": "group",
    "group": "J",
    "matchday": 2,
    "localDate": "06/22/2026 20:00",
    "date": "",
    "home": "JOR",
    "away": "ALG",
    "homeName": "Jordan",
    "awayName": "Algeria",
    "stadium": "Levi's Stadium",
    "city": "San Francisco Bay Area (Santa Clara)",
    "country": "United States",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 1,
    "awayScore": 2,
    "elapsed": "finished"
  },
  {
    "id": 45,
    "type": "group",
    "group": "K",
    "matchday": 2,
    "localDate": "06/23/2026 12:00",
    "date": "",
    "home": "POR",
    "away": "UZB",
    "homeName": "Portugal",
    "awayName": "Uzbekistan",
    "stadium": "NRG Stadium",
    "city": "Houston",
    "country": "United States",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 5,
    "awayScore": 0,
    "elapsed": "finished"
  },
  {
    "id": 46,
    "type": "group",
    "group": "L",
    "matchday": 2,
    "localDate": "06/23/2026 19:00",
    "date": "",
    "home": "PAN",
    "away": "CRO",
    "homeName": "Panama",
    "awayName": "Croatia",
    "stadium": "BMO Field",
    "city": "Toronto",
    "country": "Canada",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 0,
    "awayScore": 1,
    "elapsed": "finished"
  },
  {
    "id": 47,
    "type": "group",
    "group": "K",
    "matchday": 2,
    "localDate": "06/23/2026 20:00",
    "date": "",
    "home": "COL",
    "away": "COD",
    "homeName": "Colombia",
    "awayName": "Democratic Republic of the Congo",
    "stadium": "Estadio Akron",
    "city": "Guadalajara (Zapopan)",
    "country": "Mexico",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 1,
    "awayScore": 0,
    "elapsed": "finished"
  },
  {
    "id": 48,
    "type": "group",
    "group": "L",
    "matchday": 2,
    "localDate": "06/23/2026 16:00",
    "date": "",
    "home": "ENG",
    "away": "GHA",
    "homeName": "England",
    "awayName": "Ghana",
    "stadium": "Gillette Stadium",
    "city": "Boston (Foxborough)",
    "country": "United States",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 0,
    "awayScore": 0,
    "elapsed": "finished"
  },
  {
    "id": 49,
    "type": "group",
    "group": "C",
    "matchday": 3,
    "localDate": "06/24/2026 18:00",
    "date": "",
    "home": "SCO",
    "away": "BRA",
    "homeName": "Scotland",
    "awayName": "Brazil",
    "stadium": "Hard Rock Stadium",
    "city": "Miami (Miami Gardens)",
    "country": "United States",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 0,
    "awayScore": 3,
    "elapsed": "finished"
  },
  {
    "id": 50,
    "type": "group",
    "group": "C",
    "matchday": 3,
    "localDate": "06/24/2026 18:00",
    "date": "",
    "home": "MAR",
    "away": "HAI",
    "homeName": "Morocco",
    "awayName": "Haiti",
    "stadium": "Mercedes-Benz Stadium",
    "city": "Atlanta",
    "country": "United States",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 4,
    "awayScore": 2,
    "elapsed": "finished"
  },
  {
    "id": 51,
    "type": "group",
    "group": "A",
    "matchday": 3,
    "localDate": "06/24/2026 19:00",
    "date": "",
    "home": "RSA",
    "away": "KOR",
    "homeName": "South Africa",
    "awayName": "South Korea",
    "stadium": "Estadio BBVA",
    "city": "Monterrey (Guadalupe)",
    "country": "Mexico",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 1,
    "awayScore": 0,
    "elapsed": "finished"
  },
  {
    "id": 52,
    "type": "group",
    "group": "A",
    "matchday": 3,
    "localDate": "06/24/2026 19:00",
    "date": "",
    "home": "CZE",
    "away": "MEX",
    "homeName": "Czech Republic",
    "awayName": "Mexico",
    "stadium": "Estadio Azteca",
    "city": "Mexico City",
    "country": "Mexico",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 0,
    "awayScore": 3,
    "elapsed": "finished"
  },
  {
    "id": 53,
    "type": "group",
    "group": "B",
    "matchday": 3,
    "localDate": "06/24/2026 12:00",
    "date": "",
    "home": "BIH",
    "away": "QAT",
    "homeName": "Bosnia and Herzegovina",
    "awayName": "Qatar",
    "stadium": "Lumen Field",
    "city": "Seattle",
    "country": "United States",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 3,
    "awayScore": 1,
    "elapsed": "finished"
  },
  {
    "id": 54,
    "type": "group",
    "group": "B",
    "matchday": 3,
    "localDate": "06/24/2026 12:00",
    "date": "",
    "home": "SUI",
    "away": "CAN",
    "homeName": "Switzerland",
    "awayName": "Canada",
    "stadium": "BC Place",
    "city": "Vancouver",
    "country": "Canada",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 2,
    "awayScore": 1,
    "elapsed": "finished"
  },
  {
    "id": 55,
    "type": "group",
    "group": "E",
    "matchday": 3,
    "localDate": "06/25/2026 16:00",
    "date": "",
    "home": "CUW",
    "away": "CIV",
    "homeName": "Curaçao",
    "awayName": "Ivory Coast",
    "stadium": "Lincoln Financial Field",
    "city": "Philadelphia",
    "country": "United States",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 0,
    "awayScore": 2,
    "elapsed": "finished"
  },
  {
    "id": 56,
    "type": "group",
    "group": "E",
    "matchday": 3,
    "localDate": "06/25/2026 16:00",
    "date": "",
    "home": "ECU",
    "away": "GER",
    "homeName": "Ecuador",
    "awayName": "Germany",
    "stadium": "MetLife Stadium",
    "city": "New York/New Jersey (East Rutherford)",
    "country": "United States",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 2,
    "awayScore": 1,
    "elapsed": "finished"
  },
  {
    "id": 57,
    "type": "group",
    "group": "D",
    "matchday": 3,
    "localDate": "06/25/2026 19:00",
    "date": "",
    "home": "PAR",
    "away": "AUS",
    "homeName": "Paraguay",
    "awayName": "Australia",
    "stadium": "Levi's Stadium",
    "city": "San Francisco Bay Area (Santa Clara)",
    "country": "United States",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 0,
    "awayScore": 0,
    "elapsed": "finished"
  },
  {
    "id": 58,
    "type": "group",
    "group": "D",
    "matchday": 3,
    "localDate": "06/25/2026 19:00",
    "date": "",
    "home": "TUR",
    "away": "USA",
    "homeName": "Turkey",
    "awayName": "United States",
    "stadium": "SoFi Stadium",
    "city": "Los Angeles (Inglewood)",
    "country": "United States",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 3,
    "awayScore": 2,
    "elapsed": "finished"
  },
  {
    "id": 59,
    "type": "group",
    "group": "F",
    "matchday": 3,
    "localDate": "06/25/2026 18:00",
    "date": "",
    "home": "JPN",
    "away": "SWE",
    "homeName": "Japan",
    "awayName": "Sweden",
    "stadium": "AT&T Stadium",
    "city": "Dallas (Arlington, Texas)",
    "country": "United States",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 1,
    "awayScore": 1,
    "elapsed": "finished"
  },
  {
    "id": 60,
    "type": "group",
    "group": "F",
    "matchday": 3,
    "localDate": "06/25/2026 18:00",
    "date": "",
    "home": "TUN",
    "away": "NED",
    "homeName": "Tunisia",
    "awayName": "Netherlands",
    "stadium": "GEHA Field at Arrowhead Stadium",
    "city": "Kansas City",
    "country": "United States",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 1,
    "awayScore": 3,
    "elapsed": "finished"
  },
  {
    "id": 61,
    "type": "group",
    "group": "I",
    "matchday": 3,
    "localDate": "06/26/2026 15:00",
    "date": "",
    "home": "SEN",
    "away": "IRQ",
    "homeName": "Senegal",
    "awayName": "Iraq",
    "stadium": "BMO Field",
    "city": "Toronto",
    "country": "Canada",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 5,
    "awayScore": 0,
    "elapsed": "finished"
  },
  {
    "id": 62,
    "type": "group",
    "group": "I",
    "matchday": 3,
    "localDate": "06/26/2026 15:00",
    "date": "",
    "home": "NOR",
    "away": "FRA",
    "homeName": "Norway",
    "awayName": "France",
    "stadium": "Gillette Stadium",
    "city": "Boston (Foxborough)",
    "country": "United States",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 1,
    "awayScore": 4,
    "elapsed": "finished"
  },
  {
    "id": 63,
    "type": "group",
    "group": "G",
    "matchday": 3,
    "localDate": "06/26/2026 20:00",
    "date": "",
    "home": "EGY",
    "away": "IRN",
    "homeName": "Egypt",
    "awayName": "Iran",
    "stadium": "Lumen Field",
    "city": "Seattle",
    "country": "United States",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 1,
    "awayScore": 1,
    "elapsed": "finished"
  },
  {
    "id": 64,
    "type": "group",
    "group": "G",
    "matchday": 3,
    "localDate": "06/26/2026 20:00",
    "date": "",
    "home": "NZL",
    "away": "BEL",
    "homeName": "New Zealand",
    "awayName": "Belgium",
    "stadium": "BC Place",
    "city": "Vancouver",
    "country": "Canada",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 1,
    "awayScore": 5,
    "elapsed": "finished"
  },
  {
    "id": 65,
    "type": "group",
    "group": "H",
    "matchday": 3,
    "localDate": "06/26/2026 19:00",
    "date": "",
    "home": "CPV",
    "away": "KSA",
    "homeName": "Cape Verde",
    "awayName": "Saudi Arabia",
    "stadium": "NRG Stadium",
    "city": "Houston",
    "country": "United States",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 0,
    "awayScore": 0,
    "elapsed": "finished"
  },
  {
    "id": 66,
    "type": "group",
    "group": "H",
    "matchday": 3,
    "localDate": "06/26/2026 18:00",
    "date": "",
    "home": "URU",
    "away": "ESP",
    "homeName": "Uruguay",
    "awayName": "Spain",
    "stadium": "Estadio Akron",
    "city": "Guadalajara (Zapopan)",
    "country": "Mexico",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 0,
    "awayScore": 1,
    "elapsed": "finished"
  },
  {
    "id": 67,
    "type": "group",
    "group": "L",
    "matchday": 3,
    "localDate": "06/27/2026 17:00",
    "date": "",
    "home": "PAN",
    "away": "ENG",
    "homeName": "Panama",
    "awayName": "England",
    "stadium": "MetLife Stadium",
    "city": "New York/New Jersey (East Rutherford)",
    "country": "United States",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 0,
    "awayScore": 2,
    "elapsed": "finished"
  },
  {
    "id": 68,
    "type": "group",
    "group": "L",
    "matchday": 3,
    "localDate": "06/27/2026 17:00",
    "date": "",
    "home": "CRO",
    "away": "GHA",
    "homeName": "Croatia",
    "awayName": "Ghana",
    "stadium": "Lincoln Financial Field",
    "city": "Philadelphia",
    "country": "United States",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 2,
    "awayScore": 1,
    "elapsed": "finished"
  },
  {
    "id": 69,
    "type": "group",
    "group": "J",
    "matchday": 3,
    "localDate": "06/27/2026 21:00",
    "date": "",
    "home": "ALG",
    "away": "AUT",
    "homeName": "Algeria",
    "awayName": "Austria",
    "stadium": "GEHA Field at Arrowhead Stadium",
    "city": "Kansas City",
    "country": "United States",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 3,
    "awayScore": 3,
    "elapsed": "finished"
  },
  {
    "id": 70,
    "type": "group",
    "group": "J",
    "matchday": 3,
    "localDate": "06/27/2026 21:00",
    "date": "",
    "home": "JOR",
    "away": "ARG",
    "homeName": "Jordan",
    "awayName": "Argentina",
    "stadium": "AT&T Stadium",
    "city": "Dallas (Arlington, Texas)",
    "country": "United States",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 1,
    "awayScore": 3,
    "elapsed": "finished"
  },
  {
    "id": 71,
    "type": "group",
    "group": "K",
    "matchday": 3,
    "localDate": "06/27/2026 19:30",
    "date": "",
    "home": "COL",
    "away": "POR",
    "homeName": "Colombia",
    "awayName": "Portugal",
    "stadium": "Hard Rock Stadium",
    "city": "Miami (Miami Gardens)",
    "country": "United States",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 0,
    "awayScore": 0,
    "elapsed": "finished"
  },
  {
    "id": 72,
    "type": "group",
    "group": "K",
    "matchday": 3,
    "localDate": "06/27/2026 19:30",
    "date": "",
    "home": "COD",
    "away": "UZB",
    "homeName": "Democratic Republic of the Congo",
    "awayName": "Uzbekistan",
    "stadium": "Mercedes-Benz Stadium",
    "city": "Atlanta",
    "country": "United States",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 3,
    "awayScore": 1,
    "elapsed": "finished"
  },
  {
    "id": 73,
    "type": "r32",
    "group": "R32",
    "matchday": 4,
    "localDate": "06/28/2026 12:00",
    "date": "",
    "home": "RSA",
    "away": "CAN",
    "homeName": "South Africa",
    "awayName": "Canada",
    "stadium": "SoFi Stadium",
    "city": "Los Angeles (Inglewood)",
    "country": "United States",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 0,
    "awayScore": 1,
    "elapsed": "finished"
  },
  {
    "id": 74,
    "type": "r32",
    "group": "R32",
    "matchday": 4,
    "localDate": "06/29/2026 16:30",
    "date": "",
    "home": "GER",
    "away": "PAR",
    "homeName": "Germany",
    "awayName": "Paraguay",
    "stadium": "Gillette Stadium",
    "city": "Boston (Foxborough)",
    "country": "United States",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 1,
    "awayScore": 1,
    "elapsed": "finished"
  },
  {
    "id": 75,
    "type": "r32",
    "group": "R32",
    "matchday": 4,
    "localDate": "06/29/2026 19:00",
    "date": "",
    "home": "NED",
    "away": "MAR",
    "homeName": "Netherlands",
    "awayName": "Morocco",
    "stadium": "Estadio BBVA",
    "city": "Monterrey (Guadalupe)",
    "country": "Mexico",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 1,
    "awayScore": 1,
    "elapsed": "finished"
  },
  {
    "id": 76,
    "type": "r32",
    "group": "R32",
    "matchday": 4,
    "localDate": "06/29/2026 12:00",
    "date": "",
    "home": "BRA",
    "away": "JPN",
    "homeName": "Brazil",
    "awayName": "Japan",
    "stadium": "NRG Stadium",
    "city": "Houston",
    "country": "United States",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 2,
    "awayScore": 1,
    "elapsed": "finished"
  },
  {
    "id": 77,
    "type": "r32",
    "group": "R32",
    "matchday": 4,
    "localDate": "06/30/2026 17:00",
    "date": "",
    "home": "FRA",
    "away": "SWE",
    "homeName": "France",
    "awayName": "Sweden",
    "stadium": "MetLife Stadium",
    "city": "New York/New Jersey (East Rutherford)",
    "country": "United States",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 3,
    "awayScore": 0,
    "elapsed": "finished"
  },
  {
    "id": 78,
    "type": "r32",
    "group": "R32",
    "matchday": 4,
    "localDate": "06/30/2026 12:00",
    "date": "",
    "home": "CIV",
    "away": "NOR",
    "homeName": "Ivory Coast",
    "awayName": "Norway",
    "stadium": "AT&T Stadium",
    "city": "Dallas (Arlington, Texas)",
    "country": "United States",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 1,
    "awayScore": 2,
    "elapsed": "finished"
  },
  {
    "id": 79,
    "type": "r32",
    "group": "R32",
    "matchday": 4,
    "localDate": "06/30/2026 19:00",
    "date": "",
    "home": "MEX",
    "away": "ECU",
    "homeName": "Mexico",
    "awayName": "Ecuador",
    "stadium": "Estadio Azteca",
    "city": "Mexico City",
    "country": "Mexico",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 2,
    "awayScore": 0,
    "elapsed": "finished"
  },
  {
    "id": 80,
    "type": "r32",
    "group": "R32",
    "matchday": 4,
    "localDate": "07/01/2026 12:00",
    "date": "",
    "home": "ENG",
    "away": "COD",
    "homeName": "England",
    "awayName": "Democratic Republic of the Congo",
    "stadium": "Mercedes-Benz Stadium",
    "city": "Atlanta",
    "country": "United States",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 2,
    "awayScore": 1,
    "elapsed": "finished"
  },
  {
    "id": 81,
    "type": "r32",
    "group": "R32",
    "matchday": 4,
    "localDate": "07/01/2026 17:00",
    "date": "",
    "home": "USA",
    "away": "BIH",
    "homeName": "United States",
    "awayName": "Bosnia and Herzegovina",
    "stadium": "Levi's Stadium",
    "city": "San Francisco Bay Area (Santa Clara)",
    "country": "United States",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 2,
    "awayScore": 0,
    "elapsed": "finished"
  },
  {
    "id": 82,
    "type": "r32",
    "group": "R32",
    "matchday": 4,
    "localDate": "07/01/2026 13:00",
    "date": "",
    "home": "BEL",
    "away": "SEN",
    "homeName": "Belgium",
    "awayName": "Senegal",
    "stadium": "Lumen Field",
    "city": "Seattle",
    "country": "United States",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 3,
    "awayScore": 2,
    "elapsed": "finished"
  },
  {
    "id": 83,
    "type": "r32",
    "group": "R32",
    "matchday": 4,
    "localDate": "07/02/2026 19:00",
    "date": "",
    "home": "POR",
    "away": "CRO",
    "homeName": "Portugal",
    "awayName": "Croatia",
    "stadium": "BMO Field",
    "city": "Toronto",
    "country": "Canada",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 2,
    "awayScore": 1,
    "elapsed": "finished"
  },
  {
    "id": 84,
    "type": "r32",
    "group": "R32",
    "matchday": 4,
    "localDate": "07/02/2026 12:00",
    "date": "",
    "home": "ESP",
    "away": "AUT",
    "homeName": "Spain",
    "awayName": "Austria",
    "stadium": "SoFi Stadium",
    "city": "Los Angeles (Inglewood)",
    "country": "United States",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 3,
    "awayScore": 0,
    "elapsed": "finished"
  },
  {
    "id": 85,
    "type": "r32",
    "group": "R32",
    "matchday": 4,
    "localDate": "07/02/2026 20:00",
    "date": "",
    "home": "SUI",
    "away": "ALG",
    "homeName": "Switzerland",
    "awayName": "Algeria",
    "stadium": "BC Place",
    "city": "Vancouver",
    "country": "Canada",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 2,
    "awayScore": 0,
    "elapsed": "finished"
  },
  {
    "id": 86,
    "type": "r32",
    "group": "R32",
    "matchday": 4,
    "localDate": "07/03/2026 18:00",
    "date": "",
    "home": "ARG",
    "away": "CPV",
    "homeName": "Argentina",
    "awayName": "Cape Verde",
    "stadium": "Hard Rock Stadium",
    "city": "Miami (Miami Gardens)",
    "country": "United States",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 3,
    "awayScore": 2,
    "elapsed": "finished"
  },
  {
    "id": 87,
    "type": "r32",
    "group": "R32",
    "matchday": 4,
    "localDate": "07/03/2026 20:30",
    "date": "",
    "home": "COL",
    "away": "GHA",
    "homeName": "Colombia",
    "awayName": "Ghana",
    "stadium": "GEHA Field at Arrowhead Stadium",
    "city": "Kansas City",
    "country": "United States",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 1,
    "awayScore": 0,
    "elapsed": "finished"
  },
  {
    "id": 88,
    "type": "r32",
    "group": "R32",
    "matchday": 4,
    "localDate": "07/03/2026 13:00",
    "date": "",
    "home": "AUS",
    "away": "EGY",
    "homeName": "Australia",
    "awayName": "Egypt",
    "stadium": "AT&T Stadium",
    "city": "Dallas (Arlington, Texas)",
    "country": "United States",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 1,
    "awayScore": 1,
    "elapsed": "finished"
  },
  {
    "id": 89,
    "type": "r16",
    "group": "R16",
    "matchday": 5,
    "localDate": "07/04/2026 17:00",
    "date": "",
    "home": "PAR",
    "away": "FRA",
    "homeName": "Paraguay",
    "awayName": "France",
    "stadium": "Lincoln Financial Field",
    "city": "Philadelphia",
    "country": "United States",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 0,
    "awayScore": 1,
    "elapsed": "finished"
  },
  {
    "id": 90,
    "type": "r16",
    "group": "R16",
    "matchday": 5,
    "localDate": "07/04/2026 12:00",
    "date": "",
    "home": "CAN",
    "away": "MAR",
    "homeName": "Canada",
    "awayName": "Morocco",
    "stadium": "NRG Stadium",
    "city": "Houston",
    "country": "United States",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 0,
    "awayScore": 3,
    "elapsed": "finished"
  },
  {
    "id": 91,
    "type": "r16",
    "group": "R16",
    "matchday": 5,
    "localDate": "07/05/2026 16:00",
    "date": "",
    "home": "BRA",
    "away": "NOR",
    "homeName": "Brazil",
    "awayName": "Norway",
    "stadium": "MetLife Stadium",
    "city": "New York/New Jersey (East Rutherford)",
    "country": "United States",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 1,
    "awayScore": 2,
    "elapsed": "finished"
  },
  {
    "id": 92,
    "type": "r16",
    "group": "R16",
    "matchday": 5,
    "localDate": "07/05/2026 18:00",
    "date": "",
    "home": "MEX",
    "away": "ENG",
    "homeName": "Mexico",
    "awayName": "England",
    "stadium": "Estadio Azteca",
    "city": "Mexico City",
    "country": "Mexico",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 2,
    "awayScore": 3,
    "elapsed": "finished"
  },
  {
    "id": 93,
    "type": "r16",
    "group": "R16",
    "matchday": 5,
    "localDate": "07/06/2026 14:00",
    "date": "",
    "home": "POR",
    "away": "ESP",
    "homeName": "Portugal",
    "awayName": "Spain",
    "stadium": "AT&T Stadium",
    "city": "Dallas (Arlington, Texas)",
    "country": "United States",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 0,
    "awayScore": 1,
    "elapsed": "finished"
  },
  {
    "id": 94,
    "type": "r16",
    "group": "R16",
    "matchday": 5,
    "localDate": "07/06/2026 17:00",
    "date": "",
    "home": "USA",
    "away": "BEL",
    "homeName": "United States",
    "awayName": "Belgium",
    "stadium": "Lumen Field",
    "city": "Seattle",
    "country": "United States",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 1,
    "awayScore": 4,
    "elapsed": "finished"
  },
  {
    "id": 95,
    "type": "r16",
    "group": "R16",
    "matchday": 5,
    "localDate": "07/07/2026 12:00",
    "date": "",
    "home": "ARG",
    "away": "EGY",
    "homeName": "Argentina",
    "awayName": "Egypt",
    "stadium": "Mercedes-Benz Stadium",
    "city": "Atlanta",
    "country": "United States",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 3,
    "awayScore": 2,
    "elapsed": "finished"
  },
  {
    "id": 96,
    "type": "r16",
    "group": "R16",
    "matchday": 5,
    "localDate": "07/07/2026 13:00",
    "date": "",
    "home": "SUI",
    "away": "COL",
    "homeName": "Switzerland",
    "awayName": "Colombia",
    "stadium": "BC Place",
    "city": "Vancouver",
    "country": "Canada",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 0,
    "awayScore": 0,
    "elapsed": "finished"
  },
  {
    "id": 97,
    "type": "qf",
    "group": "QF",
    "matchday": 6,
    "localDate": "07/09/2026 16:00",
    "date": "",
    "home": "FRA",
    "away": "MAR",
    "homeName": "France",
    "awayName": "Morocco",
    "stadium": "Gillette Stadium",
    "city": "Boston (Foxborough)",
    "country": "United States",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 2,
    "awayScore": 0,
    "elapsed": "finished"
  },
  {
    "id": 98,
    "type": "qf",
    "group": "QF",
    "matchday": 6,
    "localDate": "07/10/2026 12:00",
    "date": "",
    "home": "ESP",
    "away": "BEL",
    "homeName": "Spain",
    "awayName": "Belgium",
    "stadium": "SoFi Stadium",
    "city": "Los Angeles (Inglewood)",
    "country": "United States",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 2,
    "awayScore": 1,
    "elapsed": "finished"
  },
  {
    "id": 99,
    "type": "qf",
    "group": "QF",
    "matchday": 6,
    "localDate": "07/11/2026 17:00",
    "date": "",
    "home": "NOR",
    "away": "ENG",
    "homeName": "Norway",
    "awayName": "England",
    "stadium": "Hard Rock Stadium",
    "city": "Miami (Miami Gardens)",
    "country": "United States",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 1,
    "awayScore": 2,
    "elapsed": "finished"
  },
  {
    "id": 100,
    "type": "qf",
    "group": "QF",
    "matchday": 6,
    "localDate": "07/11/2026 20:00",
    "date": "",
    "home": "ARG",
    "away": "SUI",
    "homeName": "Argentina",
    "awayName": "Switzerland",
    "stadium": "GEHA Field at Arrowhead Stadium",
    "city": "Kansas City",
    "country": "United States",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 3,
    "awayScore": 1,
    "elapsed": "finished"
  },
  {
    "id": 101,
    "type": "sf",
    "group": "SF",
    "matchday": 7,
    "localDate": "07/14/2026 14:00",
    "date": "",
    "home": "FRA",
    "away": "ESP",
    "homeName": "France",
    "awayName": "Spain",
    "stadium": "AT&T Stadium",
    "city": "Dallas (Arlington, Texas)",
    "country": "United States",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 0,
    "awayScore": 2,
    "elapsed": "finished"
  },
  {
    "id": 102,
    "type": "sf",
    "group": "SF",
    "matchday": 7,
    "localDate": "07/15/2026 15:00",
    "date": "",
    "home": "ENG",
    "away": "ARG",
    "homeName": "England",
    "awayName": "Argentina",
    "stadium": "Mercedes-Benz Stadium",
    "city": "Atlanta",
    "country": "United States",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 1,
    "awayScore": 2,
    "elapsed": "finished"
  },
  {
    "id": 103,
    "type": "third",
    "group": "3RD",
    "matchday": 8,
    "localDate": "07/18/2026 17:00",
    "date": "",
    "home": "FRA",
    "away": "ENG",
    "homeName": "France",
    "awayName": "England",
    "stadium": "Hard Rock Stadium",
    "city": "Miami (Miami Gardens)",
    "country": "United States",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 4,
    "awayScore": 6,
    "elapsed": "finished"
  },
  {
    "id": 104,
    "type": "final",
    "group": "FINAL",
    "matchday": 9,
    "localDate": "07/19/2026 15:00",
    "date": "",
    "home": "ESP",
    "away": "ARG",
    "homeName": "Spain",
    "awayName": "Argentina",
    "stadium": "MetLife Stadium",
    "city": "New York/New Jersey (East Rutherford)",
    "country": "United States",
    "source": "worldcup26.ir live API",
    "finished": true,
    "homeScore": 1,
    "awayScore": 0,
    "elapsed": "finished"
  }
];

export const tournamentStats = {
  teams: worldCupTeams.length,
  groups: worldCupGroups.length,
  matches: worldCupMatches.length,
  stadiums: worldCupStadiums.length,
  groupMatches: worldCupMatches.filter((match) => match.type === 'group').length,
  knockoutMatches: worldCupMatches.filter((match) => match.type !== 'group').length,
};
